import React from "react";
import { createContext } from "use-context-selector";
import { useAppContextState } from "../../@hooks";

const AppLastUpdateContext = createContext({});

const initialState = {
    lastUpdate: ''
}

export function AppLastUpdateProvider({ children }) {
    const { state, replaceState, resetState, updateState } = useAppContextState(initialState);

    return <AppLastUpdateContext.Provider value={{ state, replaceState, resetState, updateState }}>
        {children}
    </AppLastUpdateContext.Provider>
}

export default AppLastUpdateContext;